const ContactHeader = () => {
    return (
        <div className="w-full flex flex-col items-center gap-3 py-6">
            <h1 className="w-full lg:w-2/5 text-2xl md:text-3xl lg:text-3xl xl:text-4xl font-garamond font-bold text-cente text-heading-color text-center">Let&apos;s Build Something Exceptional Together</h1>
            <p className="flex flex-col items-center w-[80%] sm:w-[90%] md:w-4/5 lg:w-2/3 text-center font-montserrat text-text-color text-base sm:text-sm md:text-base mb-6">We&apos;re ready to help you transform your business through the power of<br/>
             intelligent, human-centered outsourcing.Whether you&apos;re looking to scale<br/>
             operations, enhance customer experience, or explore new growth<br/>
              opportunities in the U.S. our team is here to listen and guide you every step<br/>
              of the way.
            </p>
        </div>
    )
}

export default ContactHeader